import produce from 'immer'
import { createSelectionListViewContainer } from 'factories/SelectionListView'
import { t } from 'helpers/i18n'
import jobTemplateActions from 'actions/jobTemplates'
import Component from 'components/JobRequests/FormView/CreateJob/SelectJobTemplate'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) =>
      dispatch(jobTemplateActions.getOptions(params)).then((r) =>
        produce(r, (draft) => {
          if (params.pageIndex <= 1 && !params.search) {
            draft.value.data.items.unshift({ id: 0, displayName: t('none') })
            draft.value.data.recordCount++
          }
        })
      ),
  }),
})(Component)
